<div
    class="pad-l10 pad-r10"
    style="display: flex; align-items: center; grid-column: 1 / -1;"
>
    <div class="title" style="margin-top: 10px;">{{ "billing" | translate }}</div>
</div>

<!-- MOBILE -->
<ng-container *ngIf="responsive.isMobile$ | async; else desk">
    <mat-tab-group style="overflow: hidden;">
        <mat-tab [label]="'Buy Documents' | translate">
            <div class="carrousels">
                <ng-container *ngTemplateOutlet="documents"></ng-container>
            </div>
        </mat-tab>
        <mat-tab [label]="'Shipment types' | translate">
            <div class="carrousels">
                <ng-container *ngTemplateOutlet="carrousels"></ng-container>
            </div>
        </mat-tab>
        <mat-tab [label]="'Invoices' | translate">
            <ng-container *ngTemplateOutlet="invoicesTable"></ng-container>
        </mat-tab>
    </mat-tab-group>
</ng-container>

<!-- DESK -->
<ng-template #desk>
    <div class="pad-l10 pad-r10 title" style="margin-top: 15px;" fxLayout="row">
        {{ "Buy Documents" | translate }}
    </div>
    <div class="buy_documents">
        <ng-container *ngTemplateOutlet="documents"></ng-container>
    </div>
    <div class="pad-l10 pad-r10 title" style="margin-top: 15px;" fxLayout="row">
        {{ "Shipment types" | translate }}
    </div>
    <div class="shipment_types">
        <ng-container *ngTemplateOutlet="carrousels"></ng-container>
    </div>
    <div class="pad-l10 pad-r10 title" style="margin-top: 15px;" fxLayout="row">
        {{ "Invoices" | translate }}
    </div>
    <div class="invoices_table">
        <ng-container *ngTemplateOutlet="invoicesTable"></ng-container>
    </div>
</ng-template>

<ng-template #invoicesTable>
    <app-invoices-table
        [tableAdapter]="invoicesTA"
        style="overflow-y: auto; padding: 0 10px; grid-column: 1 / -1;"
    >
    </app-invoices-table>
</ng-template>

<ng-template #documents>
    <app-buy-packages-carrousel
        [packs]="packs"
        [icon]="'send'"
        [countryId]="tenant?.country_id"
        [title]="'Choose a pack' | translate"
        [docType]="'Documents' | translate"
        (buyAction)="startBuyProcess($event)"
    >
    </app-buy-packages-carrousel>
</ng-template>

<ng-template #carrousels>
    <div
        class="email_shipment mat-typography"
    >
        <mat-icon>email</mat-icon>
        <span class="shipment_title">{{("Envio email" | translate) + ": "}}</span>
        <span class="description">{{("Incluido con el pack de documentos." | translate)}}</span>
        <span class="annotation">{{"* " + ("Envio por SMS o Whatsapp conlleva coste adicional." | translate)}}</span>
    </div>

    <app-buy-packages-carrousel
        class="bg-green"
        [packs]="whatsappPacks"
        [icon]="'whatsapp'"
        [countryId]="tenant?.country_id"
        [title]="'Choose a whatsapp pack' | translate"
        [docType]="'WhatsApp messages' | translate"
        (buyAction)="startBuyProcess($event)"
    >
    </app-buy-packages-carrousel>

    <app-buy-packages-carrousel
        class="bg-red"
        [packs]="smsPacks"
        [icon]="'sms'"
        [countryId]="tenant?.country_id"
        [title]="'Choose a sms pack' | translate"
        [docType]="'Sms messages' | translate"
        (buyAction)="startBuyProcess($event)"
    >
    </app-buy-packages-carrousel>
</ng-template>
